__turbopack_context__.v({
  "vmClose": "VideoModal-module__j_jwUa__vmClose",
  "vmContent": "VideoModal-module__j_jwUa__vmContent",
  "vmModal": "VideoModal-module__j_jwUa__vmModal",
  "vmOverlay": "VideoModal-module__j_jwUa__vmOverlay",
  "vmVideo": "VideoModal-module__j_jwUa__vmVideo",
});
